// Module
var code = "<md-button class=\"md-raised\" type=\"submit\" ng-click=\"$ctrl.add()\" aria-label=\"next\">\n    <i class=\"color-green fa fa-plus-circle\" aria-hidden=\"true\"></i>\n    {{ $ctrl.title }}\n</md-button>";
// Exports
module.exports = code;